module.exports = __webpack_public_path__ + "static/media/icon_flybits.8abda715.svg";